import {
  Flex,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Text,
} from "@chakra-ui/react";
import React, { useContext } from "react";
import { YIELD_TEXT_STRINGS } from "../contants";
import { Claims, Holdings, VaultAprReports } from "@components/VaultTabs";
import useTokenBalance from "@hooks/useTokenBalance";
import { formatNumber } from "utils";
import { yieldVaultContractConfig } from "@config/contractsConfig";
import { mainnet } from "viem/chains";
import useYieldVaultClaims from "@hooks/useYieldVaultClaim";
import { YieldVaultPageContext } from "@providers/YieldVaultProvider";
import { getTagBasedOnType } from "@components/Sidebar/Sidebar";
import { SidebarTag } from "@constants/common";

const TABS_DATA = YIELD_TEXT_STRINGS.SECTIONS.PORTFOLIO.TABS;

const YieldPortfolioSection = () => {
  const { xTokenYieldVaultBalance } = useTokenBalance();
  const claims = useYieldVaultClaims();
  const { cmsAllocations } = useContext(YieldVaultPageContext);

  const holdingValue = xTokenYieldVaultBalance
    ? formatNumber(Number(xTokenYieldVaultBalance), false, 4, true)
    : "0";

  return (
    <Flex
      flexDir="column"
      gap="16px"
      w="100%"
      maxW={{ md: "736px", xl: "736px" }}
    >
      <Flex
        flexDir="column"
        pt="4px"
        pb="10px"
        gap="40px"
        borderRadius="24px"
        bg="#EBF9F9"
      >
        <Tabs>
          <TabList fontWeight="600" lineHeight="24px" overflowX="auto">
            {TABS_DATA.map((data) => (
              <Tab
                fontSize={{ base: "12px", xl: "14px" }}
                key={data.key}
                py="8px"
              >
                {data?.isNew && getTagBasedOnType(SidebarTag.INDICATOR)}
                <Text style={{ textWrap: "nowrap" }}>{data.title}</Text>
                {/* {data?.tag?.length > 0 && (
                  <Tag
                    ml={2}
                    bgColor={"textSecondary"}
                    color="white"
                    borderRadius="full"
                    fontSize="8px"
                    lineHeight={"9.6px"}
                    letterSpacing={"0.5%"}
                    fontWeight={600}
                    px={2}
                  >
                    Calculate value
                  </Tag> 
                )}*/}
              </Tab>
            ))}
          </TabList>

          <TabPanels mt={{ base: "10px", xl: "12px" }}>
            <TabPanel p="10px">
              <Holdings
                balance={holdingValue}
                symbol={yieldVaultContractConfig[mainnet.id].xToken.symbol}
              />
            </TabPanel>
            {/* <TabPanel p="10px">
              <VaultPoints data={PORTFOLIO_POINTS_DATA} />
            </TabPanel> */}
            <TabPanel p="6px">
              <Claims claims={claims} />
            </TabPanel>
            <TabPanel p="6px">
              <VaultAprReports
                cmsAllocations={cmsAllocations?.allocations || []}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Flex>
    </Flex>
  );
};

export default YieldPortfolioSection;
